import { proNavigator } from "single-spa/react-app/ProNavigator";
import { STATIC_LIST_PAGE_ROUTE } from "app/pages/sales-intelligence/constants/routes";

export const redirectToStaticList = (redirectParams: { id: string; isRecent?: boolean }): void => {
    proNavigator.go(STATIC_LIST_PAGE_ROUTE, redirectParams);
};
